const page = `
{settings}
document.title: Tillsammans igen
og.title: Tillsammans igen efter två och ett halvt år
og.image: http://quickshot.imgix.net/habib/habibstor.png?w=1200&auto=format&q=45&cs=tinysrgb
og.twitterImage: http://quickshot.imgix.net/habib/habibstor.png?w=120&h=120&fit=crop&auto=format&q=45&cs=tinysrgb
og.description: Habib lämnade sin familj i Syrien för att söka tryggheten i Sverige. I dag, två och ett halvt år senare är familjen tillsammans igen.
og.url: http://pejl.svt.se/habib-aterforenad-med-sin-familj

siteCatalyst.name: habib-aterforenad-med-sin-familj
siteCatalyst.category: lyxartikel

{}
[+page]
luft:-48px

{.bild}
storlek: full
fil: habib/habibstor.png
{}

rubrik2: Tillsammans igen

ingressmulti: För åtta månader sedan träffade vi Habib Dahe, en man som flytt från kriget i Syrien till Sverige.
ingressmulti: På sin handled bar han ett svart armband som han fått av sin då sjuåriga son Riad. Habib lämnade sin familj i Syrien för att på farliga vägar söka tryggheten i Sverige.
ingressmulti: Han fick armbandet mot löftet att han inte skulle ta av sig det förrän de sågs igen.
ingressmulti: I dag, två och ett halvt år senare, sitter armbandet på sonen Riads handled. Han är här nu, och familjen är tillsammans igen.


{.sharebuttons}
title: Tillsammans igen efter två och ett halvt år
url: http://pejl.svt.se/habib-aterforenad-med-sin-familj
{}


Habibs och sonen Riads skratt fyller rummet i lägenheten i Norrköping. Riad ligger i sängen och försöker stoppa sin pappa från att kittla honom. De båda skrattar högt men avbryter leken för en stunds allvar.
Habib frågar sin son om han kommer ihåg när han och hans syster fick veta att han skulle åka till Sverige.

– Ja, jag blev chockad. Jag och Cici sa hejdå. Jag förstod ingenting, säger Riad.

– Kommer du ihåg vad du hade köpt åt mig? undrar Habib.
{.bild}
storlek: l
fil: habib/armband-utan-tumme.png
{}
Riad lyser upp.
– Ja, armbandet! Så fort du berättat för mig att du skulle åka började jag spara pengar. När jag kom hem på dagarna var jag jättehungrig och mamma frågade om jag inte hade köpt någonting att äta med de pengar hon gav mig varje dag. Jag ville köpa någonting till dig med mina egna pengar, någonting som du kunde ha som ett minne och som du skulle ha på dig hela tiden för att komma ihåg mig.
– Du satte på mig armbandet och kramade mig och önskade mig lycka till, säger Habib. Du sa att du hoppades att vi skulle ses snart, och att jag då skulle sätta armbandet på dig istället. Hur kände du dig när jag sa hejdå och åkte iväg?

– Jag kände att jag blev klippt i två delar, och bara hälften av mitt hjärta var kvar.

{.video}
id: 13408500
storlek: l
{}

luft: 100

När vi träffade Habib Dahe första gången var [han med i projektet Syrien 200 | http://pejl.svt.se/syrien200/sv/stories/62], där 200 personer som flytt från kriget i Syrien och kommit till Sverige fick berätta sina historier. Habib hade fått sitt permanenta uppehållstillstånd i Sverige, men hans fru och två barn var kvar i Syrien. Hans berättelse tog avstamp i armbandet han fått av sin son, men handlar framförallt om de kval han lidit av att lämna sin familj.




Habib flydde till Sverige för att söka en trygg framtid för sin familj. De hade förlorat allt, men med hjälp av pengar från vänner kunde han fly. Väntan på uppehållstillstånd och familjeåterförening tog mycket längre tid än familjen förväntat sig. Det som Habib trodde skulle vara ungefär ett halvår blev två och ett halvt år utan sin fru, dotter och son.
{.video}
id: 10438141
storlek: m
bildtext: VIDEO: Så här berättade Habib när vi träffade honom första gången i slutet på sommaren år 2016.
{}
Hela tiden undrade han om han hade gjort rätt val. Det som skrämde honom mest var tanken på att något skulle hända familjen i Syrien.
Han berättar om en dag när familjen var på väg för att handla inför skolstarten. Han hade precis pratat med sin fru och visste därför var de skulle handla och vilken väg de köra. En stund efter att de lagt på tittade han på Facebook där han såg att det skett en explosion på vägen de körde. Han ringde och ringde men ingen svarade.

– Jag försökte hitta bilder på explosionen på nätet för att se om jag såg dem någonstans. Det jag kände då önskar jag att ingen ska behöva uppleva.

Men efter 45 minuter  fick han tack och lov kontakt med sin fru och fick veta att de var okej.

{.citat}
stil: strong
citat: Det går inte att sudda ut det som hände bara för att de nu är i Sverige. Det är svårt för barnen att glömma.
{}

Känslan av att ha svikit familjen växte sig också större och större. Var det rätt beslut att åka i förväg, att lämna familjen kvar och förlora vad som i slutändan blev flera år tillsammans?
Habib har flera vänner som åkte tillbaka till Syrien för att vänta på familjeåterföreningen där, tillsammans med sina familjer. Där kommer de antigen dö tillsammans eller överleva tillsammans, säger han.

– Jag frågade mig själv varför jag stannade kvar här. Min familj förlorade så mycket under väntetiden. De hamnade i farliga situationer och det går inte att sudda ut det som hände bara för att de nu är i Sverige. Det är svårt för barnen att glömma.

Habib slits mellan olika tankar. Å ena sidan fanns han inte där och kunde skydda dem. Å andra sidan var det ännu farligare för honom, som man, att stanna kvar. Sju av hans vänner hittades döda. Och efter att själv ha flytt längs farliga vägar ville han inte utsätta sin familj för den risken.

Habibs fru tog ett stort ansvar för familjen i Syrien. Förutom att ta hand om barnen så arbetade hon på ett äldreboende, ett arbete som betydde mycket för henne. Både hon och Habib hoppas få arbete här i Sverige snart.
{.bild}
storlek: wide
fil: habib/plugg.jpg
bildtext: Riad och hans syster Cecilia har redan hunnit börja i skolan. Tillsammans övar de på det svenska språket varje dag.
{}
Habibs största fokus just nu är att försöka förstå allt som har hänt familjen under tiden de var ifrån varandra. Han vill försöka gottgöra dem för allt de gick miste om när de levde i olika länder.

– Det var inte jag som satte dem i fara men det var jag som lämnade kvar dem. Nu måste jag vara bredvid dem, hos dem. Jag vill veta vad de gjorde och vad som fattades dem när jag var borta. Det är inte alltid som barnen kan uttrycka sig och berätta. De uttrycker sig på ett annat sätt än oss vuxna, säger Habib.

Men Riad, som nu är tio år, har också tänkt mycket på allt som hänt.

– Pappa lämnade mig, men han gjorde det för att det var det bästa för oss då. För att kunna ta oss ur den situationen som vi var i. Han lämnade mig för min skull – för mitt livs skull. Nu är jag här och jag är lycklig, för den halvan av mitt hjärta som var borta har kommit tillbaka till mig.


linje:
{.div}
style.maxWidth: 590px
  style.margin: 20px auto 0 auto
  style.backgroundColor: #eee


  style.paddingBottom: 5px
  style.textAlign:center
  [.+content]
  luft: -20
  {.bild}


  fil:mansour/puffbild-syr200.png
  storlek:imax
  imgix.fp-y:0
  {}
  luft:-20
  rubrikmager: [De överlevde och flydde till Sverige – läs 200 syriers berättelser | http://pejl.svt.se/syrien200 | black]
  luft:-20
  {.div}
  style.backgroundColor:#333
  style.color:#fff
  style.
  [.+content]
  rubrikmager: [pejl.svt.se/syrien200 | http://pejl.svt.se/syrien200  | white]
  []
  {}
  []
{}

linje:

{.sharebuttons}
title: Tillsammans igen efter två och ett halvt år
url: http://pejl.svt.se/habib-aterforenad-med-sin-familj
{}

linje:


rubrik5: Lava Selo
luft: -40
[ lava.selo@svt.se | mailto:lava.selo@svt.se | black]


rubrik5: Linnea Heppling
luft: -40
[ linnea.heppling@svt.se | mailto:linnea.heppling@svt.se | black]

rubrik5: Foto: Mikael Eriksson
luft: -40
[ mikael.eriksson@svt.se | mailto:mikael.eriksson@svt.se | black]

[]
`;
export default page;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/habib-aterforenad-med-sin-familj.js
 **/